export const folder = ["--------", "Energy Efficiency", "Energy Prices"];
